import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useUserStore } from '../stores/userStore'
import Options from './options'

export default function Header() {
    const welcomeMessage = useUserStore( state => state.welcomeMessage )
    const userName = useUserStore( state => state.userName )
    const editMode = useUserStore( state => state.editMode )
    const toggleEditMode = useUserStore( state => state.toggleEditMode )

    return (
        <header className={`App-header ${editMode ? '' : 'inactive' }`}>
            <div className="inner">
                <h1 className={editMode ? 'editing' : ''}><small>{welcomeMessage}</small>{userName}</h1>
                <Options />
                <div><button className={`button-edit ${editMode ? 'active' : 'inactive'}`} onClick={ toggleEditMode }>{editMode ? <FontAwesomeIcon icon="check" /> : <FontAwesomeIcon icon="pen-to-square" />}</button></div>
            </div>
        </header>
    )
}
